import { createContext, useContext, useState, ReactNode } from "react";

export interface CustomerData {
  cpf: string;
  name: string;
  email: string;
  phone: string;
}

interface SalvcarContextType {
  customerData: CustomerData | null;
  setCustomerData: (data: CustomerData | null) => void;
}

const SalvcarContext = createContext<SalvcarContextType | undefined>(undefined);

export function SalvcarProvider({ children }: { children: ReactNode }) {
  const [customerData, setCustomerData] = useState<CustomerData | null>(null);

  return (
    <SalvcarContext.Provider value={{ customerData, setCustomerData }}>
      {children}
    </SalvcarContext.Provider>
  );
}

export function useSalvcarContext() {
  const context = useContext(SalvcarContext);
  if (!context) {
    throw new Error("useSalvcarContext must be used within a SalvcarProvider");
  }
  return context;
}
